import { Spinner } from 'react-bootstrap';

function LoadSpinner({
  spinner = false,
  fullscreen = false,
  full_bg_color = 'rgba(0, 0, 0, 0.4)'
}) {

  if (fullscreen) {
    return (
        <div 
          className="position-absolute w-100 h-100"
          style={{ 
            background: full_bg_color, 
            zIndex: 999
          }}
        >
          {
            spinner &&
            <div className="spinner-container">
              <Spinner animation="border" variant="light"/>
            </div>
          }
        </div>
    )
  }

  return (
    <div id="overlay" class="d-flex flex-column align-items-center">

      {
        spinner &&
        <Spinner animation="border" role="status" variant="light">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      }
      
    </div>
  );
}

export { LoadSpinner };
